export const email = value => {
    if (!value)
        return undefined;
    return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
        ? undefined
        : { message: 'Required.' };
};
//# sourceMappingURL=email.js.map